export default "__VITE_ASSET__c4ee45c8__"